import React from 'react';
class ScrollSync extends React.Component {
  constructor(props) {
    super(props);
    this.ref = /*#__PURE__*/React.createRef();
    this.headerHeight = 0;
  }

  /**
   * Invoke this with the scroll event on the component you wish to sync with. This
   * will tell the linearView to scroll, vertically and/or horizontally, depending on
   * the values of props vertical and horizontal
   * @param {Object} evt 
   * @returns 
   */
  onScroll = evt => {
    if (this.lock === true) {
      return;
    }
    const {
      linearViewRef,
      vertical = true,
      horizontal = false
    } = this.props;
    const top = vertical ? evt.target.scrollTop : null;
    const left = horizontal ? evt.target.scrollLeft : null;
    if (linearViewRef && linearViewRef.current) {
      this.lock = true;
      window.requestAnimationFrame(() => {
        linearViewRef.current.setScroll(top, left);
        this.lock = false;
      });
    }
  };

  /**
   * This is invoked by the LinearView to indicate that a scroll in the content
   * area has occurred
   * @param {Object} evt 
   */
  onContentScroll = evt => {
    const {
      onHeaderHeightChange,
      scrollRef
    } = this.props;
    if (evt.headerHeight !== this.height) {
      this.height = evt.headerHeight;
      // if ( headerRef ) {
      //   // default behavior
      //   this.onHeaderHeightChange( this.height, evt )
      // }

      if (onHeaderHeightChange) {
        onHeaderHeightChange(this.height, evt);
      }
    }
    if (!this.lock && scrollRef.current && scrollRef.current.scrollTop !== evt.top) {
      scrollRef.current.scrollTop = evt.top;
    }
  };

  // onHeaderHeightChange = ( height ) => {
  //   const { headerHeight } = this.state
  //   if ( height !== headerHeight ) {
  //     const rh = this.headerRef && this.headerRef.current ? this.headerRef.current.clientHeight : 0
  //     const mt = `${height - rh}px`
  //     this.setState( { 
  //       style : { 
  //         height : `calc(100% - ${mt})`, 
  //         marginTop : mt }, 
  //       headerHeight : height } 
  //     )
  //   }

  // }

  render() {
    // eslint-disable-next-line react/destructuring-assignment
    return this.props.children;
  }
}
export default ScrollSync;